import React from 'react';
import { DollarSign, TrendingUp, Calendar, Clock } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export default function PaymentSummary({ statistics }) {
  if (!statistics) {
    return (
      <div className="p-4">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded mb-4"></div>
          <div className="h-20 bg-gray-200 rounded mb-4"></div>
          <div className="h-20 bg-gray-200 rounded mb-4"></div>
        </div>
      </div>
    );
  }

  const summaryItems = [
    {
      label: 'Total Recebido',
      value: `R$ ${statistics?.totalPaid?.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`,
      icon: DollarSign,
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      label: 'Total Pendente',
      value: `R$ ${statistics?.totalOutstanding?.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`,
      icon: Clock,
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    {
      label: 'Total Atrasado',
      value: `R$ ${statistics?.totalOverdue?.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`,
      icon: TrendingUp,
      bgColor: 'bg-red-100',
      iconColor: 'text-red-600'
    },
    {
      label: 'Intervalo Médio',
      value: `${statistics?.averagePaymentInterval} dias`,
      icon: Calendar,
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600'
    }
  ];

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <h3 className="font-semibold text-gray-900">Resumo de Pagamentos</h3>
        <p className="text-xs text-gray-500 mt-1">Estatísticas gerais</p>
      </div>
      {/* Summary Cards */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {summaryItems?.map((item, index) => (
          <div key={index} className={`${item?.bgColor} rounded-lg p-4`}>
            <div className="flex items-center gap-3 mb-2">
              <div className={`p-2 rounded-lg ${item?.iconColor} bg-white`}>
                <item.icon size={20} />
              </div>
              <span className="text-xs font-medium text-gray-700">{item?.label}</span>
            </div>
            <p className="text-xl font-bold text-gray-900">{item?.value}</p>
          </div>
        ))}

        {/* Next Payment Due */}
        {statistics?.nextPaymentDue && (
          <div className="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Calendar className="text-yellow-600" size={20} />
              <span className="text-sm font-semibold text-gray-900">Próximo Vencimento</span>
            </div>
            <p className="text-lg font-bold text-yellow-700">
              {format(new Date(statistics.nextPaymentDue), 'dd/MM/yyyy', { locale: ptBR })}
            </p>
            <p className="text-xs text-gray-600 mt-1">
              {Math.ceil((new Date(statistics.nextPaymentDue) - new Date()) / (1000 * 60 * 60 * 24))} dias restantes
            </p>
          </div>
        )}

        {/* Quick Actions */}
        <div className="border-t border-gray-200 pt-4 mt-4">
          <h4 className="text-sm font-semibold text-gray-900 mb-3">Ações Rápidas</h4>
          <div className="space-y-2">
            <button className="w-full text-left px-3 py-2 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 text-sm font-medium transition-colors">
              Enviar Lembretes
            </button>
            <button className="w-full text-left px-3 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 text-sm font-medium transition-colors">
              Confirmar Pagamentos
            </button>
            <button className="w-full text-left px-3 py-2 bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100 text-sm font-medium transition-colors">
              Relatório Detalhado
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}